module.exports = __webpack_public_path__ + "img/corehcms_dashboard1.1fd2ca6a.png";